import * as _ from 'lodash'
import React, { useState } from 'react';
import * as actions from '../actions';
import * as contractorActions from '../contractorActions';
import componentServices from '../componentServices';
import valueFilters from '../valueFilters';
import util from '../util';
import keyboardUtil from '../keyboardUtils';
import jobCostSpecificationFactory, { IJobCostSpecification } from '../models/jobCostSpecificationModel';
import { IJobCostWorkArea } from 'Scripts/models/jobCostWorkAreaModel';
import { IJobCostLineItem } from 'Scripts/models/jobCostLineItemModel';
import globalRelay from '../globalRelay';
import enums from '../enum';
import * as fileActions from '../fileActions';
import * as vendorActions from '../vendorActions';
import ImportWorkAreasModal from './jobCostImportWorkAreasModal';
import { useDragDrop } from '../draggable';
import { DragItemType } from '../dragItemTypes';
import { Confirm, Expander, Header, jobCostRowOwner, JobCostHiddenWhenLocked, JobCostLockable, PhotoModal, TooltipTarget } from './sharedComponents';
import { getCollection, getModel,  ModelCollection } from 'Scripts/store';

const KEY_DOWN_CODES = [13];

class CreateWorkArea extends React.Component<any,any> {
	constructor (props) {
		super(props);

		this.state = this.getStateFromProps();

		this.handleAddWorkArea = this.handleAddWorkArea.bind(this);
		this.handleOnInputChanged = this.handleOnInputChanged.bind(this);
		this.handleImportBuilderTemplate = this.handleImportBuilderTemplate.bind(this);
	}

	UNSAFE_componentWillReceiveProps () {
		this.setState(this.getStateFromProps());
	}

	getStateFromProps () {
		const { jobCost } = this.props;
		const { store } = componentServices;
		const job = getModel({ store, collection: ModelCollection.jobs, key: jobCost.jobKey });
		const state = _.assign({}, this.state, { workAreaName: '', buiderTemplates: []});

		if (job && job.builderKey) {
			if (!state.builder || state.builder.key !== job.builderKey) {
				state.builder = getModel({ store, collection: ModelCollection.contractors, key: job.builderKey});
				state.builderTemplates = [];

				if (state.builder) {
					state.fetchedBuilderKey = undefined;

					const jobCosts = getCollection({ store, collection: ModelCollection.jobCosts});
					jobCosts.forEach(jc => {
						if (jc.contractorKey === state.builder.key && jc.workAreas.length() && jc.companyVariant === jobCost.companyVariant) {
							state.builderTemplates.push(jc);
						}
					});
				}
				else if (state.fetchedBuilderKey !== job.builderKey) {
					// this prevents endless fetch calls if the builder somehow went missing
					state.fetchedBuilderKey = job.builderKey;
					contractorActions.fetchContractor({ key: job.builderKey });
				}
			}
		}
		else {
			state.builderTemplates = [];
			state.builder = undefined;
			state.fetchedBuilderKey = undefined;
		}

		return state;
	}

	handleOnInputChanged (e) {
		this.setState({ workAreaName: e.target.value });
	}

	handleAddWorkArea () {
		const workAreaName = valueFilters.clean(this.state.workAreaName);

		if (!workAreaName || workAreaName.length === 0) {
			return;
		}

		// The parameter should provide a function that accepts model as a parameter
		this.props.updateModel(jobCost => {
			const workArea = jobCost.createWorkArea({ name: workAreaName });

			jobCost.workAreas.set(workArea.key, workArea);
		}, { autoSave: true });
	}

	handleImportBuilderTemplate () {
		const { jobCost } = this.props;
		const { builderTemplates } = this.state;

		actions.pushModal({
			component: (<ImportWorkAreasModal close={ actions.popModal } targetJobCost={ jobCost } contractorTemplates={ builderTemplates } />)
		});
	}

	render () {
		const { jobCost } = this.props;
		const { builderTemplates, workAreaName } = this.state;
		const globalConfig = globalRelay.config!;

		const workAreaOptions = _.map(globalConfig.jobCostSettings.workAreas.defaultAreas, name => {
			return (
				<option key={name} value={name} />
			);
		});

		const addFromTemplate:JSX.Element[] = [];

		if (builderTemplates.length) {
			addFromTemplate.push(<td key="add"><button style={{ width: '100%' }} onClick={this.handleImportBuilderTemplate}><span>Import from Builder Model</span></button></td>);
			addFromTemplate.push(<td key="or" className="centered">or</td>);
		}

		return (
			<JobCostLockable jobCost={ jobCost } lockedClass="disabled" preventClaimOverride={ true }>{ ({ getClassName }) =>
				(<div className={ getClassName(['inner']) }>
					<table cellPadding="0" cellSpacing="0">
						<tbody>
							<tr>
								<td />
								{addFromTemplate}
								<td>
									<input type="text" className="dataList" list="workarea" name="workarea" 
										value={workAreaName} placeholder="Enter or Select a New Work Area Name" 
										onChange={this.handleOnInputChanged} 
										onKeyDown={(e) => keyboardUtil.onKeyDownCallback(e, KEY_DOWN_CODES, this.handleAddWorkArea)}/>
									<datalist id="workarea">
										{ workAreaOptions }
									</datalist>
								</td>
								<td className="action"><button className="icon iconOnly addItem" onClick={this.handleAddWorkArea}><span /></button></td>
								<td />
							</tr>
						</tbody>
					</table>
				</div>)
			}
			</JobCostLockable>
		);
	}
}

class CopyWorkAreaSpecs extends React.Component<any,any> {
	constructor (props) {
		super(props);

		this.state = { copyInfo: { selectAll: 0 }};

		_.forEach(props.otherWorkAreas, f => {
			this.state.copyInfo[f.key] = { selected: 0, workArea: f };
		});

		this.handleOnInputChanged = this.handleOnInputChanged.bind(this);
		this.handleSelectAllClick = this.handleSelectAllClick.bind(this);
	}

	handleOnInputChanged (e) {
		this.setState({ workAreaName: e.target.value });
	}

	handleCancelCopyClick () {
		actions.popModal();
	}

	handleCopyClick () {
		const workAreaName = this.state.workAreaName;

		// The parameter should provide a function that accepts model as a parameter
		this.props.copyWorkAreaHandler(workAreaName, _.map(_.filter(this.state.copyInfo, (v, k) => {
			return k !== 'selectAll' && v.selected;
		}), def => def.workArea));

		actions.popModal();
	}

	handleSelectAllClick () {
		const nextState = {...this.state};

		nextState.copyInfo.selectAll = !nextState.copyInfo.selectAll;

		_.forEach(this.props.otherWorkAreas, f => {
			nextState.copyInfo[f.key].selected = nextState.copyInfo.selectAll;
		});

		this.setState(nextState);
	}

	handleWorkAreaSelected (key) {
		const nextState = {...this.state};

		nextState.copyInfo[key].selected = !(nextState.copyInfo[key].selected);
		nextState.copyInfo.selectAll = _.every(nextState.copyInfo, (v, k) => {
			return k === 'selectAll' || v.selected;
		});

		this.setState(nextState);
	}

	render () {
		const { otherWorkAreas, workArea } = this.props;
		const globalConfig = globalRelay.config!;

		const workAreaOptions = _.map(globalConfig.jobCostSettings.workAreas.defaultAreas, name => {
			return (
				<option key={name} value={name} />
			);
		});

		const workAreaCheckBoxOptions = _.map(otherWorkAreas, workAreaCheckBoxOption => {
			return (
				<tr key={workAreaCheckBoxOption.key}>
					<td />
					<td><label><input type="checkbox" checked={util.reactVal(this.state.copyInfo[workAreaCheckBoxOption.key].selected)} onChange={this.handleWorkAreaSelected.bind(this, workAreaCheckBoxOption.key)} />{workAreaCheckBoxOption.name}</label></td>
					<td />
				</tr>
			);
		});

		return (
			<div className="window">
				<header>
					<button key="cancel" className="cancel" onClick={this.handleCancelCopyClick.bind(this, true)}><span>Cancel</span></button>
					<span>{ `Copy ${workArea.name} Specs` }</span>
					<button key="save" className="action save" onClick={this.handleCopyClick.bind(this, true)}><span>OK</span></button>
				</header>
				<div className="views">
					<div className="content in scrollable">
						<section>
							<div className="inner">
								<table className="full" cellPadding="0" cellSpacing="0">
									<thead>
										<tr>
											<td />
											<td><input type="text" className="dataList" list="workarea" name="workarea" placeholder="Add a New Work Area" onChange={this.handleOnInputChanged} />
												<datalist id="workarea">
													{ workAreaOptions }
												</datalist>
											</td>
											<td />
										</tr>
										<tr>
											<td />
											<td><label><input type="checkbox" checked={util.reactVal(this.state.copyInfo.selectAll)} onChange={this.handleSelectAllClick} />Select All</label></td>
											<td />
										</tr>
									</thead>
									<tbody>
										{ workAreaCheckBoxOptions }
									</tbody>
								</table>
							</div>
						</section>
					</div>
				</div>
			</div>
		);
	}
}

interface IWorkAreaDeleteInfo<TModel> {
	[key: string]: {
		key: string;
		delete: boolean;
		destination: IJobCostWorkArea;
		discriminator: string;
		items: TModel[];
	};
}

function DeleteWorkArea({ key, workArea, otherWorkAreas, deleteWorkAreaHandler, jobCostLineItems, jobCostSpecifications, target, windowSize }: { key: string, workArea: IJobCostWorkArea, otherWorkAreas: IJobCostWorkArea[], deleteWorkAreaHandler: any /*TODO: type this*/, jobCostLineItems: IJobCostLineItem[], jobCostSpecifications: IJobCostSpecification[], target: EventTarget & HTMLSelectElement, windowSize: { width: number, height: number } }) {

	const workAreaOptions: JSX.Element[] = [];
	const [workAreaDeleteInfo, setWorkAreaDeleteInfo] = useState(createInitialWorkAreaDeleteInfoState({ jobCostSpecifications: jobCostSpecifications, jobCostLineItems: jobCostLineItems }));

	workAreaOptions.push(<option key="unknown">Select</option>);
	otherWorkAreas.forEach(workAreaOption => {
		workAreaOptions.push(<option key={workAreaOption.key} value={workAreaOption.key}>{workAreaOption.name}</option>);
	});
	const disableEntry = (otherWorkAreas.length === 0) ? 'disabled' : '';

	function createInitialWorkAreaDeleteInfoState({ jobCostSpecifications, jobCostLineItems }: { jobCostSpecifications: IJobCostSpecification[], jobCostLineItems: IJobCostLineItem[] }) {
		const initialState: IWorkAreaDeleteInfo<IJobCostSpecification | IJobCostLineItem> = {};
		_.reduce(jobCostSpecifications, (g, i) => {
			const key = enums.specGroups.getDisplayName(i.group);
			if (!g[key]) {
				g[key] = { key: key, delete: false, destination: undefined, discriminator: 'spec', items: [] };
			}
			g[key].items.push(i);
			return g;
		}, (_.reduce(jobCostLineItems, (g, i) => {
			const key = i.type
			if (!g[key]) {
				g[key] = { key: key, delete: false, destination: undefined, discriminator: 'lineItem', items: [] };
			}
			g[key].items.push(i);
			return g;
		}, initialState)))
	
		return initialState
	}

	function handleCancelDeleteClick() {
		actions.popModal();
	}

	function handleDeleteClick(jobCostItems) {
		let isValid = true;

		_.forEach(jobCostItems, jobCostItem => {
			if ((workAreaDeleteInfo[jobCostItem.key].delete === false) && (workAreaDeleteInfo[jobCostItem.key].destination === undefined)) {
				isValid = false;
			}
		});

		// TODO (TSF)  Should we display an error message ?
		if (!isValid) {
			return;
		}

		// The parameter should provide a function that accepts model as a parameter
		deleteWorkAreaHandler(workAreaDeleteInfo);

		actions.popModal();
	}

	function handleDeleteLineItemClick(key: string, e: React.ChangeEvent<HTMLInputElement>) {
		const newVal = e.target.checked;
		const nextState = _.assign({}, workAreaDeleteInfo);
		nextState[key] = { key: key, delete: newVal, destination: undefined, discriminator: workAreaDeleteInfo[key].discriminator, items: workAreaDeleteInfo[key].items };
		setWorkAreaDeleteInfo(nextState)
	}

	function handleReAssignLineItemClick(key: string, e: React.ChangeEvent<HTMLSelectElement>) {
		const destinationKey = e.target.value;
		const nextState = _.assign({}, workAreaDeleteInfo);
		nextState[key] = { key: key, delete: false, destination: destinationKey, discriminator: workAreaDeleteInfo[key].discriminator, items: workAreaDeleteInfo[key].items };
		setWorkAreaDeleteInfo(nextState)
	}

	const jobItems = _.map(workAreaDeleteInfo, item => {
		return (
			<tr key={item.key}>
				<td></td>
				<td>{_.startCase(item.key)}</td>
				<td><label><input type="checkbox" checked={util.reactVal(workAreaDeleteInfo[item.key].delete)} onChange={e => handleDeleteLineItemClick(item.key, e)} /></label></td>
				<td className={disableEntry}>
					<select disabled={!!disableEntry} className="select" placeholder="Select" value={util.reactVal(item.destination)} onChange={e => handleReAssignLineItemClick(item.key, e)}>
						{workAreaOptions}
					</select>
				</td>
				<td />
			</tr>
		);
	});

	return (
		<div className="window">
			<header>
				<button className="cancel" onClick={() => handleCancelDeleteClick()}><span>Cancel</span></button>
				<span>Delete {workArea.name}</span>
				<button className="action save" onClick={() => handleDeleteClick(jobItems)}><span>OK</span></button>
			</header>
			<div className="views">
				<div className="content in scrollable">
					<section>
						<header><span className="centered">You're about to delete a Work Area. What would you like to do with the following Job Cost items?</span></header>
						<div className="inner">
							<table className="" cellPadding="0" cellSpacing="0">
								<thead>
									<tr>
										<td />
										<td>Type</td>
										<td>Delete</td>
										<td>Reassign to</td>
										<td />
									</tr>
								</thead>
								<tbody>
									{jobItems}
								</tbody>
							</table>
						</div>
					</section>
				</div>
			</div>
		</div>
	)
}

class CustomSpecRow extends React.Component<any,any> {
	constructor (props) {
		super(props);

		this.state = { shouldValidate: props.alwaysValidate };
		this.handleButtonClick = this.handleButtonClick.bind(this);
	}

	updateModel (path, autoSave, e) {
		e.preventDefault();

		const newVal = (autoSave) ? valueFilters.clean(e.target.value) : e.target.value;

		this.props.updateModel(model => {
			model.setAt(path, newVal);
		}, { autoSave: autoSave });
	}

	validate (property?) {
		if (!property || this.state.shouldValidate) {
			const result = !this.props.spec.test(property);

			return result;
		}
		return true;
	}

	handleButtonClick (e) {
		e.preventDefault();

		const valid = this.validate();

		if (!valid) {
			this.setState({ shouldValidate: true });
		}
		else {
			// this assumes that the add handler succeeds
			this.setState({ shouldValidate: this.props.alwaysValidate });
		}

		this.props.buttonHandler(valid, e);
	}

	render () {
		const { classNames = [], buttonClass, spec } = this.props;

		return (
			<tr className={ classNames.join(' ') }>
				<td />
				<td className={ this.validate('name') ? '' : 'required' }>
					<input type="text" placeholder="Enter a Custom Spec" value={spec.viewValue('name')} 
						onChange={this.updateModel.bind(this, 'name', false)} 
						onBlur={this.updateModel.bind(this, 'name', true)}
						onKeyDown={(e) => keyboardUtil.onKeyDownCallback(e, KEY_DOWN_CODES, () => this.handleButtonClick(e))}/>
				</td>
				<td className={ this.validate('value') ? '' : 'required' }>
					<input type="text" placeholder="Enter a Custom Value" value={spec.viewValue('value')} 
						onChange={this.updateModel.bind(this, 'value', false)} 
						onBlur={this.updateModel.bind(this, 'value', true)}
						onKeyDown={(e) => keyboardUtil.onKeyDownCallback(e, KEY_DOWN_CODES, () => this.handleButtonClick(e))}/>
				</td>
				<td className="action"><button className={buttonClass} onClick={this.handleButtonClick}><span /></button></td>
				<td />
			</tr>
		);
	}
}

const CustomSpecs = jobCostRowOwner({ listAccessor: model => model.specifications, listFilterThunkFactory: () => row => row.group === enums.specGroups.Work_Area_Custom }, class CustomSpecsComponent extends React.Component<any,any> {
	constructor (props) {
		super(props);

		this.state = this.getStateFromProps(props);
	}

	getStateFromProps (props) {
		const state = _.assign({}, this.state);

		if (!state.pendingSpec) {
			state.pendingSpec = this.createPendingSpec(props);
		}

		return state;
	}

	createPendingSpec (props) {
		return jobCostSpecificationFactory({ group: enums.specGroups.Work_Area_Custom, workAreaKey: props.workAreaKey });
	}

	addSpec (specKey, isValid) {
		if (!isValid) {
			return;
		}

		const { workAreaKey, updateModel, sortRows } = this.props;

		updateModel(model => {
			if (specKey === this.state.pendingSpec.key) {
				this.state.pendingSpec.sortIndex = _.filter(model.specifications, { group: enums.specGroups.Work_Area_Custom, workAreaKey: workAreaKey }).length;

				model.specifications.add(this.state.pendingSpec);

				sortRows(model);

				this.setState({ pendingSpec: this.createPendingSpec(this.props) });
			}
		}, { autoSave: true });
	}

	updateModel (key, updater, options) {
		this.props.updateModel(jobCost => {
			let spec = jobCost.specifications.get(key);

			if ((!spec) && (key === this.state.pendingSpec.key)) {
				spec = this.state.pendingSpec;
				options.autoSave = false;
			}

			if (spec) {
				updater(spec);
			}
		}, options);
	}

	render () {
		const { getRowClasses, jobCost, workAreaKey, rowContextMenuHandler } = this.props;

		const customSpecifications = _.filter(jobCost.specifications, { group: enums.specGroups.Work_Area_Custom, workAreaKey: workAreaKey });

		const specifications = _.map(_.sortBy(customSpecifications, 'sortIndex'), spec => {
			return (
				<CustomSpecRow key={spec.rowKey} updateModel={this.updateModel.bind(this, spec.key)} buttonHandler={ rowContextMenuHandler.bind(this, spec) } spec={spec} classNames={ getRowClasses({ item: spec, baseClassNames: ['added']}) } buttonClass="icon iconOnly contextMenu" draggable={false} alwaysValidate={true} />
			);
		});

		return (
			<table className="compact custom">
				<tbody>
					<JobCostHiddenWhenLocked jobCost={ jobCost }><CustomSpecRow key={this.state.pendingSpec.key} updateModel={this.updateModel.bind(this, this.state.pendingSpec.key)} buttonHandler={this.addSpec.bind(this, this.state.pendingSpec.key)} classNames={ ['addRow'] } spec={this.state.pendingSpec} buttonClass="icon iconOnly addItem" /></JobCostHiddenWhenLocked>
					{specifications}
				</tbody>
			</table>

		);
	}
});

function WorkArea(props) {
	const { store } = componentServices;
	const {
		allowedContractEdits,
		customSpecs,
		dropWorkArea,
		workArea,
		specifications,
		hasSpecs,
		toggleExpander,
		isExpanded,
		handleOnKeyDown,
		deleteWorkAreaHandler, 
		updateModel, 
		hasJobCostLineItems,
		hasApplianceSpecs, 
		copyFactory, 
		deleteFactory,
		...childProps } = props;
	const [{isDragging, dragSourceRef, dragPreviewRef, dropItem, dropTargetRef}] = useDragDrop({ 
		type: DragItemType.JOBCOST_WORKAREA,
		dragItem: { key: workArea.key, sortIndex: workArea.sortIndex },
		canDrop: (dragItem, dropItem) => dragItem.key !== dropItem.key,
		handleDrop: dropWorkArea
	});
	const handleUpdate = (path, autoSave, e) => {
		e.preventDefault();

		let newVal;

		if (path === 'note') {
			newVal = (autoSave) ? valueFilters.trim(e.target.value) : e.target.value;
		}
		else {
			newVal = (autoSave) ? valueFilters.clean(e.target.value) : e.target.value;
		}

		updateModel(model => {
			model.setAt(path, newVal);
		}, { autoSave: autoSave });
	}

	const deleteWorkArea = () => {
		actions.popModal();

		deleteWorkAreaHandler(undefined);
	}

	const handleDeleteWorkAreaClick = (e) => {
		if (hasJobCostLineItems || hasApplianceSpecs) {
			actions.pushModal({ component: deleteFactory(e) });
		}
		else {
			const popup = <Confirm title="Permanently Delete Work Area?" message="Are you sure you want to permanently delete this Work Area? This cannot be undone." confirmLabel="Permanently Delete" cancelLabel="Cancel" cancelHandler={ actions.popModal } confirmHandler={ deleteWorkArea } />;

			actions.popModal();
			actions.pushModal({ component: popup });
		}
	}

	const handleCopySpecsClick = (e) => {
		actions.pushModal({ component: copyFactory(e) });
	}

	const globalConfig = globalRelay.config!;
	const rowClassNames = allowedContractEdits === 'none' ? ['readOnly'] : [];
	const vendorRowClassNames = allowedContractEdits !== 'all' ? ['readOnly'] : [];
	let dropClass;

	if (dropItem && dropItem.key !== workArea.key) {
		const dropIndex = workArea.sortIndex;
		const dragIndex = dropItem.sortIndex;
		dropClass = (dropIndex > dragIndex) ? 'dropBottom' : 'dropTop';
		// console.log(dropClass);
	}

	const workAreaOptions = _.map(globalConfig.jobCostSettings.workAreas.defaultAreas, name => {
		return (
			<option key={name} value={name} />
		);
	});

	const vendors = getCollection({ store, collection: ModelCollection.vendors}).filter(v => {
		return (v.type === enums.vendorTypes.Cabinet_Supplier);
	}).sortBy(v => v.name);

	const vendorOptions:JSX.Element[] = [];

	vendorOptions.push(<option key="unknown" value="">Select</option>);
	vendors.forEach(v => {
		vendorOptions.push(<option key={v.key} value={v.key}>{v.name}</option>);
	});
	const expanderActions = [<button key='Copy' className={ hasSpecs && allowedContractEdits === 'all' ? '' : 'disabled'} onClick={e => handleCopySpecsClick(e) }><span>Copy Specs</span></button>];

	return (<Expander title={workArea.name} classNames={ ['draggable', 'dropTarget'].concat(dropClass) } isExpanded={ isExpanded } toggleExpander={ toggleExpander } actions={expanderActions} dragSourceRef={ allowedContractEdits === 'all' ? dragSourceRef : null } dragPreviewRef={ allowedContractEdits === 'all' ? dragPreviewRef : null } dropTargetRef={ allowedContractEdits === 'all' ? dropTargetRef : null }>
		<div className="inner">

			<table className="compact" cellPadding="0" cellSpacing="0">
				<tbody>
					<tr className={ rowClassNames.join(' ') }>
						<td />
						<td><strong>Name</strong></td>
						<td><input type="text" className="dataList js-key-focus-13" list="workarea" name="workarea" 
							placeholder="Enter or Select the Work Area Name" value={workArea.viewValue('name')} 
							onChange={e => handleUpdate('name', false, e)} 
							onBlur={e => handleUpdate('name', true, e)} 
							onKeyDown={handleOnKeyDown}/>
						<datalist id="workarea">
							{ workAreaOptions }
						</datalist>
						</td>
						<td />
					</tr>
					<tr className={ rowClassNames.join(' ') }>
						<td />
						<td><strong>Work Area Notes</strong><TooltipTarget text="Notes here will be printed on the work area specs of contract"><button tabIndex={-1} className="icon iconOnly info"><span /></button></TooltipTarget></td>
						<td><textarea style={allowedContractEdits === 'none' ? {pointerEvents: 'stroke'} :{}} className="js-key-focus-13" value={workArea.viewValue('note')} onChange={e => handleUpdate('note', false, e)} onBlur={e => handleUpdate('note', true, e)} /></td>
						<td />
					</tr>
					<tr className={ vendorRowClassNames.join(' ') }>
						<td />
						<td><strong>Manufacturer</strong></td>
						<td className={workArea.vendorKey ? '' : 'required'}>
							<select className="js-key-focus-13" placeholder="Select" 
								value={workArea.viewValue('vendorKey')} 
								onChange={e => handleUpdate('vendorKey', true, e)}>
								{ vendorOptions }
							</select>
						</td>
						<td />
					</tr>
					{ specifications }
				</tbody>
			</table>
			{ customSpecs }
			<JobCostHiddenWhenLocked jobCost={ childProps.jobCost }><table className="compact"><tbody><tr><td /><td /><td className="right"><button className="labelOnly deleteItem" onClick={handleDeleteWorkAreaClick}>Delete {_.startCase(workArea.name)}</button></td></tr></tbody></table></JobCostHiddenWhenLocked>
		</div>
	</Expander>
	);
}

class SpecPhoto extends React.PureComponent<any, any> {
	constructor (props) {
		super(props);

		this.handleFileChange = this.handleFileChange.bind(this);
		this.handleImageClick = this.handleImageClick.bind(this);
	}

	handleFileChange (e) {
		e.preventDefault();
		const { canEdit, jobKey, specKey } = this.props;
		const file = e.target.files[0];

		if (canEdit) {
			fileActions.enqueueUpload({ rootKey: jobKey, rootType: 'job', file, group: 'specphotos', relatedType: 'spec', relatedTypeKey: specKey });
		}
	}

	handleImageClick () {
		const { canEdit, image } = this.props;

		actions.pushModal({
			component: <PhotoModal file={ image } preventDelete={ !canEdit } />,
			props: { classNames: ['photo']}
		});
	}

	render () {
		const style:React.CSSProperties = {};
		const { canEdit, image } = this.props;

		if (image) {
			style.backgroundImage = 'url(' + image.url + ')';
		}
		const buttonClass = !image ? 'uploadPhoto add' : 'uploadPhoto';
		const input = !image ? <input type="file" onChange={this.handleFileChange} accept="image/*" capture="environment" disabled={ !canEdit } /> : undefined;

		return (
			<div className={ !image && !canEdit ? 'photoControl disabled' : 'photoControl' }>
				<div className={ buttonClass } onClick={ image ? this.handleImageClick : undefined } style={{ backgroundImage: image ? `url(${image.url})` : undefined }} />
				{ input }
			</div>
		);
	}
}

class WorkAreaSpecification extends React.Component<any,any> {
	shouldComponentUpdate (nextProps) {
		const currentSpec = this.props.spec;
		const nextSpec = nextProps.spec;

		return nextProps.image !== this.props.image || _.some(['value', 'disabled', 'locked', 'model', 'values'], p => {
			if (p === 'values') {
				return nextSpec.values.length !== currentSpec.values.length || !!_.difference(nextSpec.values, currentSpec.values).length || !!_.difference(currentSpec.values, nextSpec.values).length;
			}
			else {
				return nextSpec[p] !== currentSpec[p];
			}
		});
	}

	updateModel (autoSave, e) {
		e.preventDefault();
		const newVal = (autoSave) ? valueFilters.clean(e.target.value) : e.target.value;

		this.props.updateModel(model => {
			model.setValue(newVal || '');
		}, { autoSave: autoSave });
	}

	render () {
		const { spec, locked, image, isChangeOrder, handleOnKeyDown } = this.props;
		const identifier = 'WorkAreaSpec-' + spec.key;
		const jobKey = componentServices.routeParams.jobkey;
		let canEditPhoto = !locked && !isChangeOrder;

		const specValuesOptions = _.map(spec.values, option => {
			return (
				<option key={option} value={option}>{option}</option>
			);
		});

		let inputTd;

		if (!spec.hasValues || locked) {
			inputTd = <td key="input"><input className="js-key-focus-13" type="text" placeholder={ locked ? 'N/A' : 'Enter' } 
				value={util.reactVal(spec.value)} onChange={this.updateModel.bind(this, false)} 
				onBlur={this.updateModel.bind(this, true)} onKeyDown={handleOnKeyDown}/></td>;
		}
		else if (spec.preventCustomValue) {
			specValuesOptions.unshift(<option key="unknown" value="">{ locked ? 'N/A' : 'Select' }</option>);
			inputTd = <td key="input"><select className="js-key-focus-13" value={util.reactVal(spec.value)} 
				onChange={this.updateModel.bind(this, true)}>{ specValuesOptions }</select></td>;
		}
		else {
			inputTd = (<td key="input"><input type="text" className="dataList js-key-focus-13" list={identifier} 
				placeholder={ locked ? 'N/A' : 'Enter or Select' } value={util.reactVal(spec.value)} 
				onChange={this.updateModel.bind(this, false)} onBlur={this.updateModel.bind(this, true)} 
				onKeyDown={handleOnKeyDown}/>
			<datalist id={identifier}>
				{ specValuesOptions }
			</datalist>
			</td>);
		}

		const rowClassNames = spec.disabled ? ['disabled'] : [];
		if (spec.model && spec.model.isChange) {
			rowClassNames.push('changed');
			rowClassNames.push(spec.model.action === enums.trackableActions.Set ? 'modified' : 'removed');
			canEditPhoto = spec.model.action === enums.trackableActions.Set;
		}

		if (locked || spec.autoSet) {
			rowClassNames.push('readOnly');
		}

		return (
			<tr className={ rowClassNames.join(' ') }>
				<td />
				<td><strong>{spec.label}</strong></td>
				{ inputTd }
				<td className={ locked || !spec.model ? 'action disabled' : 'action' }>
					{ jobKey && spec.allowImage ? <SpecPhoto canEdit={ canEditPhoto } jobKey={ jobKey } specKey={ spec.model && spec.model.key } image={ image } /> : null }
				</td>
			</tr>
		);
	}
}

export default class JobCostEditWorkAreas extends React.Component<any,any> {
	private _configFetches;

	constructor (props) {
		super(props);

		this.state = {
			workAreaExpanderState: {}
		};

		this._configFetches = {};

		this.addWorkArea = this.addWorkArea.bind(this);
		this.handleWorkAreaDrop = this.handleWorkAreaDrop.bind(this);
		this.collapseAll = this.collapseAll.bind(this);
	}

	componentDidMount () {
		const { routeParams, store } = componentServices;
		const jobKey = routeParams.jobkey;
		const job = jobKey && getModel({ store, collection: ModelCollection.jobs, key: jobKey });

		vendorActions.fetchCabinetSuppliers();
		if (job) {
			fileActions.fetchFilesForJob({ job });
		}
	}

	addWorkArea (updater, options) {
		this.props.updateModel(model => {
			model.workAreas = model.workAreas || [];

			updater(model);

			// if (options.autoSave) {
			// 	model.sortWorkAreas();
			// }
		}, options);
	}

	copyWorkAreaHandler (workAreaKey, newWorkAreaName, destinationWorkAreas) {
		this.props.updateModel(model => {
			model.copyWorkArea(workAreaKey, newWorkAreaName, destinationWorkAreas);
		}, { autoSave: true });
	}

	deleteWorkAreaHandler(workAreaKey, deleteInfo) {
		this.props.updateModel(model => {
			const { store } = componentServices;
			const workArea = model.workAreas.get(workAreaKey);

			// 1.  Need to re-assign/delete job cost items
			// -  Grab the jobcost.lineitems with the given type on the current work area and re-assign the work area to the destination work area key
			// -  If they chose to delete them, then delete them off of the current jobcost.lineitems
			// 2.  need to delete all data associated with this work area key
			if (deleteInfo) {
				_.forEach(deleteInfo, f => {
					if (f.discriminator === 'lineItem') {
						_.forEach(f.items, item => {
							if (f.delete) {
								model.lineItems.delete(item.key);
							}
							else if (f.destination) {
								const lineItem = _.find(model.lineItems, { key: item.key });

								lineItem.workAreaKey = f.destination;
							}
						})
					}
					else if (f.discriminator === 'spec') {
						_.forEach(f.items, item => {
							if (f.delete) {
								model.specifications.delete(item.key);
							}
							else if (f.destination) {
								const spec = _.find(model.specifications, { key: item.key });

								spec.workAreaKey = f.destination;
							}
						})
					}
				});
			}

			// Only delete after all the re-assignments have been completed
			if (workArea) {
				_.forEach(_.filter(model.settings, { workAreaKey: workAreaKey }), s => {
					model.settings.delete(s.key);
				});
				_.forEach(_.filter(model.specifications, spec => spec.workAreaKey === workAreaKey && spec.group !== enums.specGroups.Appliance), s => {
					const specFile = getCollection({ store, collection: ModelCollection.files }).find(f => {
						return f.relatedTypeKey === s.key;
					});
					if (specFile) {
						fileActions.deleteFile({ file: specFile });
					}
					model.specifications.delete(s.key);
				});
				model.workAreas.delete(workAreaKey);
			}

			//model.sortWorkAreas();
		}, { autoSave: true });
	}

	// model in this case is the jobcost
	updateWorkArea (workAreaKey, updater, options) {
		this.props.updateModel(model => {
			const { store } = componentServices;
			const workArea = model.workAreas.get(workAreaKey);
			const currentVendorKey = workArea.vendorKey;

			updater(workArea);

			if (currentVendorKey !== workArea.vendorKey) {
				_.forEach(model.cabinetSpecs.getSpecifications(workAreaKey), s => {
					const specFile = getCollection({ store, collection: ModelCollection.files}).find(f => {
						return f.relatedTypeKey === s.key;
					});

					if (specFile) {
						fileActions.deleteFile({ file: specFile });
					}
				});

				model.cabinetSpecs.clear(workAreaKey);
			}

			// if (options.autoSave) {
			// 	model.sortWorkAreas();
			// }
		}, options);
	}

	updateWorkAreaSpec (specKey, workAreaKey, updater, options) {
		this.props.updateModel((model, updateCallback) => {
			const { store } = componentServices;
			const item = _.find(model.cabinetSpecs.items(workAreaKey), { key: specKey }) || _.find(model.workAreaSpecs.items(workAreaKey), { key: specKey });

			if (item) {
				updater(item, updateCallback);

				const itemAfterUpdate = _.find(model.cabinetSpecs.items(workAreaKey), { key: specKey }) || _.find(model.workAreaSpecs.items(workAreaKey), { key: specKey });

				if (item.model) {
					const files = getCollection({ store, collection: ModelCollection.files });
					let specFile;
					if (!itemAfterUpdate.model) {
						specFile = files.find(f => {
							return f.relatedTypeKey === item.model.key;
						});
					}
					else if (item.model.isChange && itemAfterUpdate.model.key !== item.model.key) {
						specFile = files.find(f => {
							return f.relatedTypeKey === item.model.key;
						});
					}

					if (specFile) {
						fileActions.deleteFile({ file: specFile });
					}
				}
			}
		}, options);
	}

	handleWorkAreaDrop (sourceItem, targetItem) {
		this.props.updateModel(jobCost => {
			const sourceArea = jobCost.workAreas[sourceItem.key];
			const targetArea = jobCost.workAreas[targetItem.key];
			const targetSortIndex = targetArea.sortIndex;

			if (sourceArea.sortIndex > targetSortIndex) {
				_.forEach(jobCost.workAreas, area => {
					if (area.sortIndex >= targetSortIndex) {
						area.sortIndex += 1;
					}
				});
			}
			else {
				_.forEach(jobCost.workAreas, area => {
					if (area.sortIndex <= targetSortIndex) {
						area.sortIndex -= 1;
					}
				});
			}

			sourceArea.sortIndex = targetSortIndex;
		}, { autoSave: true });
	}

	getVendorConfig (key) {
		const { store } = componentServices;
		const { jobCost } = this.props;
		const globalConfig = globalRelay.config!.withVariant(jobCost.companyVariant);
		const vendor = getModel({ store, collection: ModelCollection.vendors, key });
		let vendorName = vendor && _.camelCase(vendor.name);
		let version = globalConfig.jobCostSettings.specifications.cabinetSpecVersions[vendorName];

		if (!version) {
			vendorName = 'default';
			version = globalConfig.jobCostSettings.specifications.cabinetSpecVersions[vendorName];
		}

		if (!version) {
			return;
		}

		const vendorConfigName = _.kebabCase(vendorName) + '-cabinet-specs-' + version.toLowerCase();
		const config = componentServices.store.getIn(['model', 'config', _.camelCase(vendorConfigName)]);

		if (!config) {
			if (!this._configFetches[vendorConfigName]) {
				actions.fetchConfig({ name: vendorConfigName });
				this._configFetches[vendorConfigName] = true;
			}
			return undefined;
		}

		return { config, version, vendorName, configName: vendorConfigName };
	}

	collapseAll () {
		const { jobCost } = this.props;
		const workAreas = jobCost.workAreas ? jobCost.workAreas.toArray() : [];

		this.setState(previousState => {
			const result = _.assign({}, previousState);

			_.forEach(workAreas, workArea => {
				result.workAreaExpanderState[workArea.key] = false;
			});

			return result;
		});
	}

	toggleExpander (workArea) {
		const expanded = this.state.workAreaExpanderState[workArea.key];

		this.setState(previousState => {
			const result = _.assign({}, previousState);

			result.workAreaExpanderState[workArea.key] = typeof (expanded) === 'undefined' ? false : !expanded;

			return result;
		});
	}

	getWorkAreaConfig (workAreaName) {
		if (!workAreaName) {
			return undefined;
		}

		const workAreaSpecDefinitionSetting = this.props.jobCost.getSetting(enums.jobCostSettingGroups.General, 'workAreaSpecDefinition');

		if (!workAreaSpecDefinitionSetting) {
			return undefined;
		}

		const workAreaConfigName = workAreaSpecDefinitionSetting.value;
		const config = componentServices.store.getIn(['model', 'config', _.camelCase(workAreaConfigName)]);
		
		if (!config) {
			if (!this._configFetches[workAreaConfigName]) {
				actions.fetchConfig({ name: workAreaConfigName });
				this._configFetches[workAreaConfigName] = true;
			}
			return undefined;
		}

		return { config: config, configName: workAreaConfigName };
	}

	render () {
		// Get the job cost that is passed in on the props
		const { store } = componentServices;
		const files = getCollection({ store, collection: ModelCollection.files });
		const { jobCost, updateModel } = this.props;
		const { workAreaExpanderState } = this.state;
		const globalConfig = globalRelay.config!.withVariant(jobCost.companyVariant);
		const allowedContractEdits = jobCost.allowedContractEdits;
		const currentWorkAreas = jobCost.workAreas ? jobCost.workAreas.toArray() : [];
		const titlebarActions = [<button onClick={ this.collapseAll }><span>Collapse All</span></button>, <button><span>Print Styles</span></button>, <button><span>Print Finishes</span></button>];

		const workAreas = _.map(_.sortBy(currentWorkAreas, 'sortIndex'), workArea => {
			const vendorConfig = this.getVendorConfig(workArea.vendorKey);
			const workAreaConfig = this.getWorkAreaConfig(workArea.name);
			const hasVendorSpecs = (vendorConfig && vendorConfig.vendorName !== 'default');
			const specifications:JSX.Element[] = [];
			const isExpanded = typeof (workAreaExpanderState[workArea.key]) === 'undefined' ? true : workAreaExpanderState[workArea.key];

			if (vendorConfig) {
				jobCost.cabinetSpecs.setDefinition(workArea.key, vendorConfig.config, vendorConfig.configName);
			}

			if (workAreaConfig && workAreaConfig.config) {
				jobCost.workAreaSpecs.setDefinition(workArea.key, workAreaConfig.config, workAreaConfig.configName);
			}
			const specList = _.filter(jobCost.cabinetSpecs.items(workArea.key), { hidden: false });
			const workAreaList = _.filter(jobCost.workAreaSpecs.items(workArea.key), { hidden: false });

			_.forEach(specList, i => {
				const specFile = i.model && files.find(f => {
					return f.relatedTypeKey === i.model.key;
				});

				specifications.push(
					<JobCostLockable key={`${i.key}-cabinet`} jobCost={ jobCost } lockChangeOrders={ true }>{ ({ isLocked }) =>
						<WorkAreaSpecification spec={i} image={ specFile } isChangeOrder={ !!jobCost.currentChangeOrder } 
							locked={ isLocked } updateModel={this.updateWorkAreaSpec.bind(this, i.key, workArea.key)}
							handleOnKeyDown = { (e) => keyboardUtil.onKeyDownInputEvent(e)} />
					}
					</JobCostLockable>
				);
			});

			_.forEach(workAreaList, i => {
				const specFile = i.model && files.find(f => {
					return f.relatedTypeKey === i.model.key;
				});

				specifications.push(
					<JobCostLockable key={`${i.key}-workArea`} jobCost={ jobCost }>{ ({ isLocked }) =>
						<WorkAreaSpecification key={`${i.key}-workArea`} spec={i} isChangeOrder={ !!jobCost.currentChangeOrder } 
							image={ specFile } locked={ isLocked } updateModel={this.updateWorkAreaSpec.bind(this, i.key, workArea.key)}
							handleOnKeyDown = { (e) => keyboardUtil.onKeyDownInputEvent(e)} />
					}
					</JobCostLockable>
				);
			});

			const otherWorkAreas = _.filter(jobCost.workAreas, f => { return f.key !== workArea.key;});

			const copyFactory = e => {
				const windowSize = componentServices.store.getIn(['viewState', 'metrics', 'windowSize']).toJS();

				return (<CopyWorkAreaSpecs key={workArea.key} workArea={workArea} otherWorkAreas={otherWorkAreas} copyWorkAreaHandler={this.copyWorkAreaHandler.bind(this, workArea.key)} target={e.target} windowSize={windowSize} />);
			};

			const deleteFactory = e => {
				const windowSize = componentServices.store.getIn(['viewState', 'metrics', 'windowSize']).toJS();

				return (<DeleteWorkArea key={workArea.key} workArea={workArea} otherWorkAreas={otherWorkAreas} deleteWorkAreaHandler={this.deleteWorkAreaHandler.bind(this, workArea.key)} jobCostLineItems={_.filter(jobCost.lineItems, { workAreaKey: workArea.key })} jobCostSpecifications={_.filter(jobCost.specifications, { group: enums.specGroups.Appliance, workAreaKey: workArea.key })} target={e.target} windowSize={windowSize} />);
			};

			const hasSpecs = (jobCost.workAreaSpecs.getSpecifications(workArea.key).length + jobCost.cabinetSpecs.getSpecifications(workArea.key).length + _.filter(jobCost.specifications, { group: enums.specGroups.Work_Area_Custom }).length) > 0;
			const customSpecs = hasVendorSpecs || !globalConfig.jobCostSettings.specifications.allowCustom ? null : <CustomSpecs jobCost={ jobCost } workAreaKey={ workArea.key } updateModel={ updateModel } />;

			return (
				<WorkArea
					key={workArea.key}
					customSpecs={ customSpecs }
					jobCost={jobCost}
					updateModel={this.updateWorkArea.bind(this, workArea.key)}
					dropWorkArea={ this.handleWorkAreaDrop }
					workArea={workArea}
					specifications={specifications}
					vendorConfig={vendorConfig}
					copyFactory={copyFactory}
					deleteFactory={deleteFactory}
					deleteWorkAreaHandler={this.deleteWorkAreaHandler.bind(this, workArea.key)}
					hasJobCostLineItems={((_.filter(jobCost.lineItems, { workAreaKey: workArea.key })).length > 0)}
					hasApplianceSpecs = {((_.filter(jobCost.specifications, {workAreaKey: workArea.key, group: enums.specGroups.Appliance })).length > 0)}
					hasSpecs={hasSpecs}
					allowedContractEdits={ allowedContractEdits }
					isExpanded={ isExpanded }
					toggleExpander={ this.toggleExpander.bind(this, workArea) }
					handleOnKeyDown = { (e) => keyboardUtil.onKeyDownInputEvent(e)} />
			);
		});

		return (
			<section className="jobCostWorkAreas">
				<Header title="Work Area Specs" actions={ titlebarActions } />
				<section className="expander expanded">
					<CreateWorkArea updateModel={this.addWorkArea} jobCost={jobCost} allowedContractEdits={ allowedContractEdits } />
					{ workAreas }
				</section>
			</section>

		);
	}
}
